import Store from "../context";
import Fetcher from "../fetcher";
import getChargeData from "../init/chargedata";
import AmountState from "../context/common/amount";
import InfoState from "../context/common/info";
import { isPlainObject, getValueAtPath, isBoolean, isFunction } from "../utils";

import {
  DEFAULT_POST_INIT,
  DEFAULT_RETRY_CONDITIONS,
  DEFAULT_TIMEOUT,
  isJsonResponse,
  withSharedHeaders
} from "../fetcher/utils";

let SHOULD_FETCH_FEE;
let INITIAL_CHARGE_AMOUNT;

const FEES_CACHE = Object.create(null);
const FEE_API_ENDPOINT = `${process.env.API_BASE_URL}/v3/checkout/fee`;

// const FeeObject = Object.freeze(function () {});

const $fetch = withSharedHeaders(Fetcher.one
  .limit(3)
  .init(DEFAULT_POST_INIT)
  .retry(...DEFAULT_RETRY_CONDITIONS)
  .timeout(DEFAULT_TIMEOUT));

const ERR_FETCH_FEE_FAILURE = (function __fetchFeeFailureError__() {
  const err = new Error('FETCH_FEE_FAILED');
  err.name = 'ERR_FETCH_FEE_FAILURE';
  return Object.freeze(err);
})();

function __shouldFetchFee__(executor) {
  return new Promise((resolve, reject) => {
    const shouldFetch = isBoolean(SHOULD_FETCH_FEE)
      ? Promise.resolve(SHOULD_FETCH_FEE)
      : getChargeData().then(data => {
        return (SHOULD_FETCH_FEE = !getValueAtPath(data, 'preferences[merchant_bears_fees]'));
      });

    shouldFetch.then(shouldFetch => {
      // if (shouldFetch === true && isFunction(executor)) {
        executor(resolve, reject);
      // }
    }).finally(resolve);
  });
}

// function __fee__(feeData) {
//   if (isPlainObject(feeData)) {
//     const { amount, charge_amount, currency } = feeData;

//     return Object.create(FeeObject.prototype, {
//       amount: { value: amount || 0 },
//       chargeAmount: { value: charge_amount || 0 },
//       currency: { value: currency }
//     });
//   }
// }

// function __isFeeObject__(value) {
//   return value &&
//     isPlainObject(value) &&
//     Object.getPrototypeOf(value) === FeeObject.prototype;
// }

// function __getInitialChargeFee__() {
//   return __init__()
//     .then(data => {
//       if (isPlainObject(data) && isPlainObject(data.initial)) {
//         const { amount, currency, charge_amount, merchant_bears } = data.initial;
//       }
//     });
// }

function __fetchChargeFee__(card6) {
  return getChargeData().then($chargedata => {
    const currency = $chargedata.currency;
    let payment_method = getValueAtPath(Store.getState(), 'method.current');
    let network = getValueAtPath(Store.getState(), "view.context.inputs['network'].value") ? getValueAtPath(Store.getState(), "view.context.inputs['network'].value").identifier : "MTN";
    let country = getValueAtPath(Store.getState(), "view.context.inputs['country'].value") ? getValueAtPath(Store.getState(), "view.context.inputs['country'].value").code : ""

    if (payment_method === 'card') {
      const canSwitchToPaymob = getValueAtPath($chargedata, 'preferences[can_switch_to_paymob]') === true;
      if (currency === 'EGP') {
        if (canSwitchToPaymob) {
          payment_method = 'paymob'
        } else if (!canSwitchToPaymob && card6 && /^\d{6}$/.test(card6)) {
          payment_method = card6;
        }
      }

      if (card6 && /^\d{6}$/.test(card6)) {
        payment_method = card6;
      }
    }

    // This shouldn't be done normally, but Abiodun (current BE engineer for Checkout V3) says there's another 
    // fee setup for "1voucher" in his codebase and doing this on his end would cause a clash, hence this update.
    // Ideally, sending the payment_method is already enough for the fee endpoint
    if (payment_method === '1voucher') {
      payment_method = 'flashvoucher';
    }

    if (!INITIAL_CHARGE_AMOUNT) {
      INITIAL_CHARGE_AMOUNT = $chargedata.amount;
    }

    let amount = INITIAL_CHARGE_AMOUNT;

    let cache_key = btoa(`${currency}::${payment_method}`);

    let payload = {
      amount,
      currency,
      payment_method,
      public_key: $chargedata.PBFPubKey,
      checkout_id: $chargedata.modalauditid
    };

    if (payment_method === 'mobilemoneytanzania') {
      payload['network'] = getValueAtPath($chargedata, 'mobilemoney_network') || null;
      payload['payment_method'] = 'MOBILEMONEY';
    }

    if (['mobilemoneyghana', 'mobilemoneyfranco', 'mobilemoneytanzania', 'mobilemoneyzambia'].includes(payment_method)) {
      const selectedNetwork = getValueAtPath(Store.getState(), "view.context.inputs['network'].value");
      const selectedCountry = getValueAtPath(Store.getState(), "view.context.inputs['country'].value");
      network = selectedNetwork.identifier;
      payload['network'] = selectedNetwork.identifier || getValueAtPath($chargedata, 'mobilemoney_network') || null;

      switch (payment_method) {
        case 'mobilemoneyghana':
          payload['country'] = 'GH';
          country = 'GH';
          break;
        case 'mobilemoneyfranco':
          payload['country'] = selectedCountry.code || getValueAtPath($chargedata, 'country') || null;
          country = selectedCountry.code;
          break;
        case 'mobilemoneytanzania':
          payload['country'] = 'TZ';
          country = 'TZ';
          break;
        case 'mobilemoneyzambia':
          payload['country'] = 'ZM';
          country = 'ZM';
          break;
        default:
          break;
      }
      cache_key = btoa(`${currency}::${payment_method}::${network}::${country}`);
    }
    
    if (FEES_CACHE[cache_key]) {
      try {
        const { dispatch } = Store;

        const currentFeeData = { ...FEES_CACHE[cache_key] };

        const { charge_amount, dcc, ...remainingFeeData } = currentFeeData;
        const fee = dcc && dcc.fee ? dcc.fee : currentFeeData.fee;
        const dccAvailable = dcc ? true : false;
        
        let remainingFeeDataToBeSubtracted = 0;

        if (Object.keys(remainingFeeData).length > 1) {
          const listOfFeeDataWithNumberTypeValues =
            Object.values(remainingFeeData).filter(item => typeof item === 'number');
          remainingFeeDataToBeSubtracted = listOfFeeDataWithNumberTypeValues.length > 0 
            ? listOfFeeDataWithNumberTypeValues.reduce((acc, curr) => {return acc + curr}, 0)
            : 0;
        }

        const amount = dcc 
          ? dcc.charge_amount 
          : (parseFloat(charge_amount) - parseFloat(remainingFeeDataToBeSubtracted));

        if (dcc) {
          dcc && dcc.rate ? delete dcc.rate : void 0;
          dcc && dcc.intlfee ? delete dcc.intlfee : void 0;
          dcc && dcc.ravefee ? delete dcc.ravefee : void 0;
        }
        
        if (currentFeeData['currency']) { delete currentFeeData['currency'] }
        if (currentFeeData['charge_amount']) { delete currentFeeData['charge_amount'] }
        if (currentFeeData['dcc']) { delete currentFeeData['dcc'] }
        if (currentFeeData['ravefee']) { delete currentFeeData['ravefee'] }
        if (currentFeeData['intlfee']) { delete currentFeeData['intlfee'] }

        const feeData = dcc ? { ...dcc } : { amount, ...(fee && fee), ...currentFeeData };
        setTimeout(() =>  dispatch(InfoState.actions.updateInfo({ dccAvailable, feeData })), 10)
      } catch (error) {}

      return Promise.resolve(FEES_CACHE[cache_key]);
    }
    
    return $fetch(FEE_API_ENDPOINT, {
      body: JSON.stringify(payload)
    }).then(response => {
      if (isJsonResponse(response) && response.ok) {
        return response.json()
          .then(response => {
            if (isPlainObject(response) && isPlainObject(response.data)) {
              let finalAmount;
              let discountAmount = null;
              const { charge_amount, dcc } = { ...response.data };
              const { dispatch } = Store;

              if (getValueAtPath(Store.getState(), 'campaign') && 
                Object.keys(getValueAtPath(Store.getState(), 'campaign')).length > 0
              ) {
                let discounted_value = getValueAtPath(Store.getState(), 'campaign')['discounted_value'];
                discountAmount = discounted_value;
                let calculatedFee = parseFloat(charge_amount) - parseFloat(INITIAL_CHARGE_AMOUNT);
                finalAmount = (parseFloat(INITIAL_CHARGE_AMOUNT) - parseFloat(discounted_value)) + parseFloat(calculatedFee);
              } else {
                finalAmount = charge_amount;
              }

              setTimeout(() => {
                delete response.data.currency;
                delete response.data.charge_amount;
                delete response.data.dcc;
                let feeData;

                const remainingData = dcc ? { ...dcc } : { ...response.data };
                const dccAvailable = dcc ? true : false;

                if (discountAmount !== null) {
                    feeData = {
                      amount: dcc ? dcc.amount : payload.amount,
                      discount: discountAmount,
                      ...remainingData,
                    }
                } else {
                    feeData = {
                    amount: dcc ? dcc.amount : payload.amount,
                    ...remainingData,
                  }
                }

                if (feeData['charge_amount']) { delete feeData['charge_amount'] }
                if (feeData['rate']) { delete feeData['rate']  }
                if (feeData['ravefee']) { delete feeData['ravefee'] }
                if (feeData['intlfee']) { delete feeData['intlfee'] }
                
                dispatch(InfoState.actions.updateInfo({ dccAvailable, feeData }))
              }, 10);

              Object.defineProperty(FEES_CACHE, cache_key, {
                value: { 'charge_amount': finalAmount.toFixed(2), dcc, ...(discountAmount !== null && { discount: discountAmount }), ...response.data }
              });

              return FEES_CACHE[cache_key];
            }

            return Promise.reject([ ERR_FETCH_FEE_FAILURE, currency, payment_method ]);
          });
      }

      return Promise.reject([ ERR_FETCH_FEE_FAILURE, currency, payment_method ]);
    });
  });
}

function __getChargeFee__(card6) {
  if (getValueAtPath(Store.getState(), 'session.expired')) return;
  __shouldFetchFee__((resolve, reject) => {
    const { dispatch } = Store;

    dispatch(InfoState.actions.updateInfo({ amountUpdate: true }));

    __fetchChargeFee__(card6)
      .then(
        chargeAmount => {
          // Session may have expired during the fetch — don't apply a stale fee.
          if (getValueAtPath(Store.getState(), 'session.expired')) {
            dispatch(InfoState.actions.updateInfo({ amountUpdate: false }));
            return;
          }
          dispatch(AmountState.actions.updateChargeAmount(chargeAmount));
          resolve(chargeAmount);
          dispatch(InfoState.actions.updateInfo({ amountUpdate: false }));
        },
        (err) => {
          const [$err, currency, payment_method] = [].concat(err);
          let amount = INITIAL_CHARGE_AMOUNT;

          if (payment_method === card6) {
            const fallback_card_cache_key = btoa(`${currency}::card`);
            amount = FEES_CACHE[fallback_card_cache_key] || INITIAL_CHARGE_AMOUNT;
          }

          let discounted_value = getValueAtPath(Store.getState(), 'campaign')['discounted_value'];
          if (amount && typeof amount === 'number') {
            amount = (amount - discounted_value).toFixed(2);
          }

          dispatch(AmountState.actions.updateChargeAmount(amount));
          reject($err);
          dispatch(InfoState.actions.updateInfo({ amountUpdate: false }));
        }
      );
  });
}

export default __getChargeFee__;